<template>
  <ComponenteLoading :is-loading="isLoading" :message="mensajeLoadingComputed"></ComponenteLoading>

  <v-card-title>{{ $t('configuracion.titulo') }}</v-card-title>
  <v-divider></v-divider>
  <v-row class="ma-4">
    
    <!-- FECHA ACTUAL -->
    <v-col cols="4" sm="3">
      <VueDatePicker 
        model-type="dd/MM/yyyy" 
        v-model="configuracionLocal.fechaActual" 
        :format="'dd/MM/yyyy'" 
        text-input             
        :teleport="true"
        @update:modelValue="emitirCambioFecha"
         :auto-apply="true"
      />
    </v-col>

    <!-- HORIZONTE (DÍAS) -->
    <v-col cols="4" sm="3">
      <v-select
        v-model="configuracionLocal.horizonte"
        :items="horizonteOpciones"
        :label="$t('configuracion.horizonte_dias')"
        variant="outlined"
        density="compact"
        :disabled="horizonteDeshabilitado"
        @update:modelValue="emitChanges"
      ></v-select>
    </v-col>

    <!-- SELECCIÓN DE PRECIOS -->
    <v-col cols="4" sm="3">
      <v-select
        v-model="configuracionLocal.precios"
        :items="preciosOpciones"
        item-title="text"
        item-value="value"
        :label="$t('configuracion.precios')"
        variant="outlined"
        density="compact"
        :disabled="modoEjecucionDeshabilitaPrecios"
        @update:modelValue="actualizarConfiguracion"
      ></v-select>
    </v-col>

    <!-- SELECCIÓN DE MODO DE EJECUCIÓN -->
    <v-col cols="4" sm="3">
      <v-select
        v-model="configuracionLocal.modoEjecucion"
        :items="modoEjecucionOpciones"
        item-title="text"
        item-value="value"
        :label="$t('configuracion.modo_ejecucion')"
        variant="outlined"
        density="compact"
        @update:modelValue="actualizarModoEjecucion"
      ></v-select>
    </v-col>

    <!-- CASILLA MES BACKTESTING 
    <v-col cols="4" sm="3" v-if="configuracionLocal.modoEjecucionTexto === 'Backtesting'">
      <VueDatePicker
         @update:modelValue="handleMesBacktesting"
        v-model="mesBacktestingLocal"
        :label="$t('configuracion.mes_backtesting')"
        text-input
        :teleport="true"
        :month-picker="true"
        model-type="MM/yyyy"
        format="MM/yyyy" 
        locale="es"
        :min-date="new Date(2000, 0, 1)" 
        :max-date="new Date()" 
      />
    </v-col>
    <v-col cols="4" sm="3" v-if="configuracionLocal.modoEjecucionTexto === 'Backtesting'">
      <v-text-field
        v-model="mesBacktestingLocal"
        :label="$t('configuracion.mes_backtesting')"
        type="month"
        variant="outlined"
        density="compact"
      ></v-text-field>
    </v-col>-->
    <!-- CASILLA MES PLANIFICACION 
    <v-col cols="4" sm="3" v-if="configuracionLocal.modoEjecucionTexto === 'Planificación'">
      <VueDatePicker
        @update:modelValue="handleMesPlanificacion"
        v-model="mesPlanificacionLocal"
        :label="$t('configuracion.mes_planificacion')"
        text-input
        :teleport="true"
        :month-picker="true"
        model-type="MM/yyyy"
        format="MM/yyyy" 
        locale="es"
        :min-date="new Date(2000, 0, 1)" 
        :max-date="new Date()" 
      />
    </v-col>
    <v-col cols="4" sm="3" v-if="configuracionLocal.modoEjecucionTexto === 'Planificación'">
      <v-text-field
        v-model="mesPlanificacionLocal"
        :label="$t('configuracion.mes_planificacion')"
        type="month"
        variant="outlined"
        density="compact"
      ></v-text-field>
    </v-col>-->
  </v-row>
  <v-container>
    <v-dialog v-model="showAlert" max-width="400">
      <v-card>
        <v-card-title class="headline">⚠️ Atención</v-card-title>
        <v-card-text>{{ error_msg }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="showAlert = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import ComponenteLoading from "@/components/ComponenteLoading.vue";
export default {
  components: {
    ComponenteLoading,
  },
  props: {
    modelValue: Object,
    //mesBacktesting: String,
    //mesPlanificacion: String,
    
  },
  data() {
  
    return {
      mensaje_loading: "",
      isLoading: false,
      error_msg: "",
      showAlert: false,
      horizonteOpciones: [1],
      horizonteDeshabilitado: false,
      preciosOpciones: [
        { text: this.$t("configuracion.opciones_precios.omie"), value: "OMIE" },
        { text: this.$t("configuracion.opciones_precios.simulart"), value: "SimularT" },
        { text: this.$t("configuracion.opciones_precios.manual"), value: "Manual" }
      ],
      modoEjecucionOpciones: [
        { text: this.$t("configuracion.opciones_modo_ejecucion.optimizacion"), value: 0 },
        { text: this.$t("configuracion.opciones_modo_ejecucion.sin_parar_cogeneracion"), value: 1 },
        { text: this.$t("configuracion.opciones_modo_ejecucion.acoplamientos_fijados"), value: 2 },
        { text: this.$t("configuracion.opciones_modo_ejecucion.backtesting"), value: 3 },
        { text: this.$t("configuracion.opciones_modo_ejecucion.planificacion"), value: 4 }
      ],
      
      
    };
  },
  created(){
    this.actualizarPestañas(this.configuracionLocal.precios);
    
    
  },
      
  computed: {
    modoEjecucionDeshabilitaPrecios() {
      return this.configuracionLocal.modoEjecucionTexto === "Backtesting" || this.configuracionLocal.modoEjecucionTexto === "Planificación";
    },
    configuracionLocal: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      }
    },
    /*mesBacktestingLocal: {
      get() {
        return this.mesBacktesting ? this.convertirAFormatoInput(this.mesBacktesting) : "";
      },
      set(value) {
        this.$emit("update:mesBacktesting", this.convertirAFormatoMes(value));
      }
    },
    mesPlanificacionLocal: {
      get() {
        return this.mesPlanificacion ? this.convertirAFormatoInput(this.mesPlanificacion) : "";
      },
      set(value) {
        this.$emit("update:mesPlanificacion", this.convertirAFormatoMes(value));
      }
    },*/
    mensajeLoadingComputed() {
    return this.mensaje_loading; // Ahora es reactivo a los cambios
  }
  },
  methods: {
    emitirCambioFecha(nuevaFecha) {
      console.log("Nueva fecha: ", nuevaFecha)
      let partes = nuevaFecha.split('/'); 
     

      if(this.configuracionLocal.modoEjecucion==3) { //Es backtesting
        
        partes[0]= '01'
        console.log("Fecha Backtesting ", partes)
        //Elegir en backtesting el horizonte como el número de días del mes
        this.configuracionLocal.horizonte = this.diasEnElMesDesdeString(this.configuracionLocal.fechaActual);

      }else if(this.configuracionLocal.modoEjecucion==4){ //Si es planificación revisar el horizotne por año bisiesto
        const dia = parseInt(partes[0]);
        const mes = parseInt(partes[1]);  
        const anio = parseInt(partes[2]);
        const fechaObjeto = new Date(anio, mes - 1, dia);
        //Se suma un año y se calculan los días de diferencia, por si es bisiesto
        const fechaNueva = new Date(fechaObjeto);
        fechaNueva.setFullYear(fechaObjeto.getFullYear() + 1);
        const diferenciaMs = Date.parse(fechaNueva) - Date.parse(fechaObjeto);
        const milisegundosEnUnDia = 1000 * 60 * 60 * 24;
        const diferenciaDias = Math.round(diferenciaMs / milisegundosEnUnDia);
        this.configuracionLocal.horizonte = diferenciaDias;
        
      }
      let fechaModificada = partes.join('/');
      console.log("fechaActual", this.configuracionLocal.fechaActual)
      console.log("dias del mes: ", this.configuracionLocal.horizonte)
      this.$emit('fecha-cambiada', fechaModificada);
    },
    
    emitirCambioHorizonte(nuevoHorizonte) {
      this.$emit('horizonte-cambiado', nuevoHorizonte);
    },
    emitirCambioPrecio(nuevoPrecio) {
      this.$emit('precio-cambiado', nuevoPrecio);
    },
    emitChanges() {      
      this.$emit("update:modelValue", JSON.parse(JSON.stringify(this.configuracionLocal)));      
      this.$emit('horizonte-cambiado', this.configuracionLocal.horizonte)
    },

     diasEnElMesDesdeString(fechaStr) {
      const partes = fechaStr.split("/"); // ["26", "05", "2025"]
     
      const mes = parseInt(partes[1], 10) - 1; // Mes en JS empieza en 0
      const anio = parseInt(partes[2], 10);
      //console.log("Dias: ", new Date(anio, mes + 1, 0).getDate())
      // Día 0 del mes siguiente da el último día del mes actual
      return new Date(anio, mes + 1, 0).getDate();
    },
    actualizarConfiguracion(valor) {
      this.actualizarHorizonte(valor);
      this.actualizarPestañas(valor);
    },
    actualizarHorizonte(valor) {
  if (!this.modoEjecucionDeshabilitaPrecios) {
    this.horizonteOpciones = valor === "SimularT" || valor === "Manual" ? [1, 2, 3, 4, 5, 6, 7] : [1];

    // Solo actualizar si el horizonte actual no está dentro de las nuevas opciones
    if (!this.horizonteOpciones.includes(this.configuracionLocal.horizonte)) {
      this.configuracionLocal.horizonte = this.horizonteOpciones[0];
    }

    this.horizonteDeshabilitado = false;
  } else {
    this.horizonteDeshabilitado = true;
  }

  this.emitChanges();
},
    actualizarModoEjecucion(valor) { 
    this.configuracionLocal.modoEjecucionTexto = this.obtenerModoEjecucionTexto(valor);
    this.configuracionLocal.modoEjecucion = valor;

    if (this.configuracionLocal.modoEjecucionTexto === "Planificación") {
        this.mensaje_loading = "Cargando planificación... "
        this.isLoading = true; // Activar loading

        const partes = this.configuracionLocal.fechaActual.split('/'); // ["03", "10", "2025"]

      const dia = parseInt(partes[0]);
      const mes = parseInt(partes[1]);   // 10 (Octubre)
      const anio = parseInt(partes[2]);
        const fechaObjeto = new Date(anio, mes - 1, dia);
        //Se suma un año y se calculan los días de diferencia, por si es bisiesto
        const fechaNueva = new Date(fechaObjeto);
        console.log("fechaActual",fechaObjeto)
        fechaNueva.setFullYear(fechaObjeto.getFullYear() + 1);
        const diferenciaMs = Date.parse(fechaNueva) - Date.parse(fechaObjeto);
        const milisegundosEnUnDia = 1000 * 60 * 60 * 24;
        const diferenciaDias = Math.round(diferenciaMs / milisegundosEnUnDia);
        this.configuracionLocal.horizonte = diferenciaDias;
        
        this.horizonteOpciones = [diferenciaDias];
        this.horizonteDeshabilitado = true;
        this.configuracionLocal.precios = "Manual"; 

        setTimeout(() => {
          this.actualizarPestañas("Planificación");
          this.isLoading = false; // Desactivar loading después de cargar datos
        }, 50000); 

    } else if (this.configuracionLocal.modoEjecucionTexto === "Backtesting") {
      this.mensaje_loading = "Cargando backtesting... "
      this.isLoading = true; // Activar loading
      console.log("fechaActual", this.configuracionLocal.fechaActual)
      console.log("dias del mes: ", this.diasEnElMesDesdeString(this.configuracionLocal.fechaActual))
      console.log("fechaActual", this.configuracionLocal.fechaActual)
      let partes=this.configuracionLocal.fechaActual.split('/')
      partes[0]="01"
      this.configuracionLocal.fechaActual=partes.join('/')
      this.configuracionLocal.horizonte = this.diasEnElMesDesdeString(this.configuracionLocal.fechaActual);
      //this.configuracionLocal.precios = "OMIE"; // Mantener precios de OMIE
      this.horizonteDeshabilitado = true;
      this.mostrarAlertaBacktesting();
      //this.actualizarPestañas("Backtesting"); 
      setTimeout(() => {
          this.actualizarPestañas("Backtesting");
          this.isLoading = false; // Desactivar loading después de cargar datos
        }, 7000); 
    } else {
      this.horizonteOpciones = [1, 2, 3, 4, 5, 6, 7];
      this.configuracionLocal.horizonte = this.horizonteOpciones[0];
      this.horizonteDeshabilitado = false;
      this.actualizarPestañas(this.configuracionLocal.precios); // Si no es Backtesting o Planificación, usar precios
      this.actualizarHorizonte(this.configuracionLocal.precios);

    }

    this.emitChanges();
  },
    obtenerModoEjecucionTexto(valor) {
      const modoMap = {
        0: "Optimización",
        1: "Sin parar cogeneración",
        2: "Acoplamientos de cogeneración fijados",
        3: "Backtesting",
        4: "Planificación"
      };
      return modoMap[valor] || "Acoplamientos de cogeneración fijados";
    },
    mostrarAlertaBacktesting() {
      this.error_msg = this.$t("configuracion.alerta_backtesting");
      this.showAlert = true;
    },
    error(n_error) {
      switch (n_error) {
        case 1:
          this.error_msg = "Es necesario que el CSV contenga las columnas requeridas de Peajes de Electricidad";
          break;
        case 2:
          this.error_msg = "La matriz de datos debe contener 6 filas de datos, una por periodo";
          break;
      }
      this.showAlert = true;
    },
    actualizarPestañas(valor) {
    Object.keys(this.configuracionLocal.pestanas).forEach(key => {
      this.configuracionLocal.pestanas[key] = false;
    });

    if (valor === "Backtesting") {
      this.configuracionLocal.pestanas.ElecPreciosHistoricos = true;  
      this.configuracionLocal.pestanas.GasPreciosHistoricos = true;
    } else if (valor === "Planificación") {
      this.configuracionLocal.pestanas.ElecPrevisionPrecios = true; 
      this.configuracionLocal.pestanas.GasPrevisionPrecios = true;
    } else if (valor === "OMIE") {
      this.configuracionLocal.pestanas.omie = true;
      this.configuracionLocal.pestanas.mibgas = true;
    } else if (valor === "SimularT") {
      this.configuracionLocal.pestanas.previsión = true;
      this.configuracionLocal.pestanas.mibgas = true;
    }
      else if (valor === "Manual") {
        if (this.configuracionLocal.modoEjecucionTexto === "Planificación") {
          this.configuracionLocal.pestanas.ElecPrevisionPrecios = true;
          this.configuracionLocal.pestanas.GasPrevisionPrecios = true;
        } else {
          this.configuracionLocal.pestanas.manualElect = true;
          this.configuracionLocal.pestanas.manualGas = true;
        }
    }

    this.$emit("update:modelValue", this.configuracionLocal);
  },

    convertirAFormatoInput(mesAnio) {
    const meses = {
      "ene": "01", "feb": "02", "mar": "03", "abr": "04", "may": "05", "jun": "06",
      "jul": "07", "ago": "08", "sept": "09", "oct": "10", "nov": "11", "dic": "12"
    };

    const [mesTexto, anioTexto] = mesAnio.split("-");
    const anio = `20${anioTexto}`; // Convertir "24" a "2024"
    const mes = meses[mesTexto];

    return mes && anio ? `${anio}-${mes}` : "";
  },

  // Convierte "2024-01" a "ene-24"
  convertirAFormatoMes(fecha) {
    if (!fecha) return "";
    const [anio, mes] = fecha.split("-");

    const mesesInvertidos = {
      "01": "ene", "02": "feb", "03": "mar", "04": "abr", "05": "may", "06": "jun",
      "07": "jul", "08": "ago", "09": "sept", "10": "oct", "11": "nov", "12": "dic"
    };

    return `${mesesInvertidos[mes]}-${anio.slice(-2)}`;
  }
}
};
</script>